/**
 * These backend endpoints are defined here for using them multiple times in the constant definition.
 * Its not enough to add something here. These are just helper variables. If you need to add a new endpoint,
 * add a helper variable here and then use it inside the config interface service.
 *
 * @format
 */

export enum ENDPOINTS {
    // Receiving (just receiving data, not sending)
    NotificationHeaders = '/NdpHeaderSet',
    ValueHelpers = '/ValueHelperSet',
    InputFieldProperties = '/FieldPropertySet',
    WhatsNew = '/WhatsNewSet',
    ConfigSet = '/ConfigSet',
    ServiceKey = '/ServKeySet',
    F4mGetPrologueSet = '/F4M_Get_PrologueSet',
    MaterialStockSet = '/MatStockSet',
    CseDopSet = '/CseDopSet',
    CseStockSet = '/CSEStockSet',
    EncryptionKeySet = '/EncryptionKeySet',
    MeasToolSet = '/MeasToolSet',
    NotificationHistory = '/NotificationHistorySet',

    // Submitting (just sending data back, not receiving)
    AppVersionSet = '/AppVersionSet',
    NotificationCancellation = '/CancellationSet',
    MaterialPickupHeaders = '/MatPickupHeaderSet',
    MaterialReturnHeaders = '/MatReturnHeaderSet',
    NotificationConfirmation = '/CrmHeaderSet',
    NotificationOtherTasks = '/OtherTasksSet',
    NotificationCriticalityChange = '/CriticalityChangeSet',
    NotificationDurationChange = '/DurationTaskSet',
    StatusUpdate = '/TravTimeSet',
    EndOfWorkSet = '/CatslogSet',
    DeepInsertSet = '/DeepInsertSet',
    MaterialQuote = '/MatQuoteSet',
    MaterialOrder = '/MatOrderSet',
    EscalationSet = '/EscalationSet',
    DataMaintenanceEquipment = '/EquipMaintSet',
    F4mSaveXmlSet = '/F4M_Save_XMLSet',
    F4mUploadSignatureSet = '/F4M_Upload_Signature_P58Set',
    F4mReleaseLock = '/F4M_Release_LockSet',
    F4mSubmitFormSet = '/F4M_Submit_FormSet', // this is the new service that combines XML, signatures and release lock
    F4mSubmitParticipantCopySet = '/F4M_Submit_ParticipantCopySet', // this is the service to submit participant copies.
    RequestNotification = '/JobOnFlySet',
    InternalInfoSubmitSet = '/InternalInfoSubmitSet',
    F4MSubmitSpqSet = '/F4M_Submit_SPQSet',
    ApprovedPCHDuractionChange = '/PCHChangeSet',

    // Online-Only (not offline store)
    CseSale = '/NotiCreateSet',
    MatPricing = '/MatPricingSet',
    MatAvailabilitySet = '/MatAvailabilitySet',
    F4mGetListSet = '/F4M_Get_ListSet',
    F4mGetXMLSet = '/F4M_Get_XMLSet',
    F4mGetCustomXMLSet = '/F4M_Get_Custom_XMLSet',
    F4mTextTranslate = '/F4M_Text_TranslateSet',
    IsAlive = '/IsaliveSet',
    UserMasterSet = '/UserMasterSet',
    UserProfileSet = '/UserProfileSet',
    UserProfileParentSet = '/UPParentSet',
    WorkScheduleSet = '/WorkScheduleSet',
    WorkScheduleEntries = '/ScheduleSet',
    RegisterApnsPushServiceSet = '/RegisterApnsPushServiceSet',
    GlobalConfigSet = '/GlobalConfigSet',
    GetEquipmentsAndInterims = '/EquipSet',
    RefreshXML = '/RefreshXMLSet',
    MaterialSerialNumbersGet = '/CMDBResponseSet',
    SoftwareLicences = '/SoftwareLicencesSet',
    GetDocBoxListSet = '/DocBoxListSet',
    GetDocBoxDocumentsSet = '/DocBoxDocumentsSet',
    DocboxUploadSet = '/DocboxUploadSet',
    GetSPQXMLSet = '/F4M_Get_SPQ_XMLSet',
    MaterialBillingIndicatorSet = '/MatBillIndicatorSet',
    AppointmentSet = '/AppointmentSet',

    // Local-Only (not used for sending or receiving data -> maintenance endpoint
    ErrorArchive = '/ErrorArchive',

    // Simulate an empty response with an OKish HTTP status
    MockEmptyOk = '/MockEmptyOk',

    GetTestFormListSet = '/GetTestFormListSet',
}
